export function* preferenceSaga() {}

export default preferenceSaga;
